import services from '.'
import { IData } from '../@types'
import { IPromotion, IPromotionCreate } from '../@types/promotions'
import { getAxiosErrorMessage } from '../resources'

const baseURL = '/packages/promotions'

async function listPromotions(): Promise<Array<IPromotion> | undefined> {
  try {
    const promotions = await services.api
      .get<IData<Array<IPromotion>>>(baseURL)
      .then(({ data }) => data?.data)

    return promotions
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function setPromotion({
  userId,
  packageId,
}: IPromotionCreate): Promise<IPromotion | undefined> {
  try {
    const { data } = await services.api.post<IData<IPromotion>>(
      baseURL + '/set',
      {
        userId,
        packageId,
      },
    )

    if (!data?.data) throw new Error('no data returned from server')

    return data?.data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function removePromotion(userId: string): Promise<void> {
  try {
    await services.api.post(`${baseURL}/remove`, {
      userId,
    })
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default {
  listPromotions,
  setPromotion,
  removePromotion,
}
